import { z } from "zod";

export const LessonIdSchema = z
  .string()
  .regex(/^(?:L\d+|P0U-\d{3}|JBU-\d{3})$/u);

export type LessonId = z.infer<typeof LessonIdSchema>;
